import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HybridAdapterUtility } from '../../Hybrid/hybrid-adapter.utility';
import { AgGridModule } from 'ag-grid-angular';
import { WeissmanSharedModule } from '../../Common/weissman-shared.module';
import { SharedPipesModule } from '../../UI-Lib/Pipes/shared-pipes.module';
import { BusyIndicatorModule } from '../../Busy-Indicator';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { AgGridExtensionsModule } from '../../Compliance/AgGrid/agGridExtensions.module';
import { HistoryLookupService } from './historyLookup.service';
import { HistoryLookupRepository } from './historyLookup.repository';
import { HistoryLookupPageComponent } from './History-Lookup-Page/historyLookupPage.component';
import { HistoryLookupAccountNumberComponent } from './History-Lookup-Grids/historyLookupAccountNumber.component';
import { HistoryLookupAddressComponent } from './History-Lookup-Grids/historyLookupAddress.component';
import { HistoryLookupClientServiceResponsibilityComponent } from './History-Lookup-Grids/historyLookupClientServiceResponsibility.component';
import { HistoryLookupCompanyComponent } from './History-Lookup-Grids/historyLookupCompany.component';
import { HistoryLookupContactComponent } from './History-Lookup-Grids/historyLookupContact.component';
import { HistoryLookupGLAccountComponent } from './History-Lookup-Grids/historyLookupGLAccount.component';
import { HistoryLookupParcelComponent } from './History-Lookup-Grids/historyLookupParcel.component';
import { HistoryLookupParcelAssessmentClassComponent } from './History-Lookup-Grids/historyLookupParcelAssessmentClass.component';
import { HistoryLookupParcelCollectorComponent } from './History-Lookup-Grids/historyLookupParcelCollector.component';
import { HistoryLookupParcelCollectorPaymentOptionComponent } from './History-Lookup-Grids/historyLookupParcelCollectorPaymentOption.component';
import { HistoryLookupParcelCollectorTaxAuthorityComponent } from './History-Lookup-Grids/historyLookupParcelCollectorTaxAuthority.component';
import { HistoryLookupParcelDescriptorComponent } from './History-Lookup-Grids/historyLookupParcelDescriptor.component';
import { HistoryLookupSiteComponent } from './History-Lookup-Grids/historyLookupSite.component';
import { HistoryLookupSiteDescriptorComponent } from './History-Lookup-Grids/historyLookupSiteDescriptor.component';
import { HistoryLookupTaxAuthorityComponent } from './History-Lookup-Grids/historyLookupTaxAuthority.component';
import { HistoryLookupTaxRateAreaComponent } from './History-Lookup-Grids/historyLookupTaxRateArea.component';
import { HistoryLookupTransactionComponent } from './History-Lookup-Grids/historyLookupTransaction.component';

@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        WeissmanSharedModule,
        SharedPipesModule,
        BusyIndicatorModule.forRoot(),
        AgGridExtensionsModule,
        AgGridModule,
    ],
    declarations: [
        HistoryLookupPageComponent,
        HistoryLookupAccountNumberComponent,
        HistoryLookupAddressComponent,
        HistoryLookupClientServiceResponsibilityComponent,
        HistoryLookupCompanyComponent,
        HistoryLookupContactComponent,
        HistoryLookupGLAccountComponent,
        HistoryLookupParcelComponent,
        HistoryLookupParcelAssessmentClassComponent,
        HistoryLookupParcelCollectorComponent,
        HistoryLookupParcelCollectorPaymentOptionComponent,
        HistoryLookupParcelCollectorTaxAuthorityComponent,
        HistoryLookupParcelDescriptorComponent,
        HistoryLookupSiteComponent,
        HistoryLookupSiteDescriptorComponent,
        HistoryLookupTaxAuthorityComponent,
        HistoryLookupTaxRateAreaComponent,
        HistoryLookupTransactionComponent,
    ],
    providers: [HistoryLookupService, HistoryLookupRepository],
    exports: [],
})
export class HistoryLookupModule {
    static setupModule(): void {
        const hybridAdapterUtility = new HybridAdapterUtility();
        hybridAdapterUtility.downgradeNg2Component('historyLookupPage', HistoryLookupPageComponent);
        hybridAdapterUtility.downgradeNg2Component('historyLookupAccountNumber', HistoryLookupAccountNumberComponent);
        hybridAdapterUtility.downgradeNg2Component('historyLookupAddress', HistoryLookupAddressComponent);
        hybridAdapterUtility.downgradeNg2Component(
            'historyLookupClientServiceResponsibility',
            HistoryLookupClientServiceResponsibilityComponent,
        );
        hybridAdapterUtility.downgradeNg2Component('historyLookupCompany', HistoryLookupCompanyComponent);
        hybridAdapterUtility.downgradeNg2Component('historyLookupContact', HistoryLookupContactComponent);
        hybridAdapterUtility.downgradeNg2Component('historyLookupGLAccount', HistoryLookupGLAccountComponent);
        hybridAdapterUtility.downgradeNg2Component('historyLookupParcel', HistoryLookupParcelComponent);
        hybridAdapterUtility.downgradeNg2Component(
            'historyLookupParcelAssessmentClass',
            HistoryLookupParcelAssessmentClassComponent,
        );
        hybridAdapterUtility.downgradeNg2Component('historyLookupParcelCollector', HistoryLookupParcelCollectorComponent);
        hybridAdapterUtility.downgradeNg2Component(
            'historyLookupParcelCollectorPaymentOption',
            HistoryLookupParcelCollectorPaymentOptionComponent,
        );
        hybridAdapterUtility.downgradeNg2Component(
            'historyLookupParcelCollectorTaxAuthority',
            HistoryLookupParcelCollectorTaxAuthorityComponent,
        );
        hybridAdapterUtility.downgradeNg2Component('historyLookupParcelDescriptor', HistoryLookupParcelDescriptorComponent);
        hybridAdapterUtility.downgradeNg2Component('historyLookupSite', HistoryLookupSiteComponent);
        hybridAdapterUtility.downgradeNg2Component('historyLookupSiteDescriptor', HistoryLookupSiteDescriptorComponent);
        hybridAdapterUtility.downgradeNg2Component('historyLookupTaxAuthority', HistoryLookupTaxAuthorityComponent);
        hybridAdapterUtility.downgradeNg2Component('historyLookupTaxRateArea', HistoryLookupTaxRateAreaComponent);
        hybridAdapterUtility.downgradeNg2Component('historyLookupTransaction', HistoryLookupTransactionComponent);
    }
}
